import type { CSSProperties, ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { TYPE_LABEL, STATUS_LABEL } from '@/data/dictionaries';
import type { CourseStatus, CourseType } from '@/types/domain';

export type BadgeKind = 'sage' | 'ochre' | 'clay' | 'slate' | 'spark' | 'gray' | 'line' | 'safe' | 'danger';

export interface BadgeProps {
  children: ReactNode;
  kind?: BadgeKind;
  dot?: boolean;
  style?: CSSProperties;
}

export function Badge({ children, kind = 'gray', dot = false, style }: BadgeProps) {
  return (
    <span className={cn('badge', `badge-${kind}`)} style={style}>
      {dot && <span className="dot" />}
      {children}
    </span>
  );
}

export function TypeBadge({ type }: { type: CourseType }) {
  const t = TYPE_LABEL[type];
  return (
    <Badge kind={t.badge}>
      <span className="th">{t.label.th}</span> · {t.label.en}
    </Badge>
  );
}

export function StatusBadge({ status }: { status: CourseStatus }) {
  const s = STATUS_LABEL[status];
  return (
    <Badge kind={s.badge} dot>
      {s.en}
    </Badge>
  );
}

/** Coloured role chip used in the user-management table. */
export function RoleBadge({ label, kind }: { label: string; kind: BadgeKind }) {
  return <Badge kind={kind}>{label}</Badge>;
}
